
import WAlert from "@/components/data-display/WAlert.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "alerts",
  components: {
    WAlert,
  },
  data() {
    return {
      variants: [
        {
          type: "default",
          show: true,
        },
        {
          type: "info",
          show: true,
        },
        {
          type: "success",
          show: true,
        },
        {
          type: "danger",
          show: true,
        },
        {
          type: "warning",
          show: true,
        },
      ],
      variants2: [
        {
          type: "info",
          show: true,
        },
        {
          type: "success",
          show: true,
        },
        {
          type: "danger",
          show: true,
        },
        {
          type: "warning",
          show: true,
        },
      ],
    };
  },
  computed: {
    isReset(): boolean {
      return this.variants.every((variant) => {
        return !variant.show;
      });
    },
  },
  methods: {
    reset() {
      this.variants.forEach((variant, index) => {
        this.variants[index].show = true;
      });
    },
  },
});
